import { toMoment } from '@tokeet-frontend/tv3-platform'

export type EventOverlapMode = 'day' | 'hour' | 'minute' | 'second'

export function isRangeOverlapping(
  range1: { start: number; end: number },
  range2: { start: number; end: number },
  mode: EventOverlapMode = 'day',
  threshold: number = 1
) {
  if (range1.start > range2.start && range1.end < range2.end) {
    return true
  } else if (range1.start <= range2.start && range1.end >= range2.end) {
    return true
  } else if (range1.start < range2.start && range1.end > range2.start) {
    if (checkOverlapThreshold(range2.start, range1.end, mode, threshold)) {
      return true
    }
  } else if (range1.start < range2.end && range1.end > range2.end) {
    if (checkOverlapThreshold(range1.start, range2.end, mode, threshold)) {
      return true
    }
  }
  return false
}

export function checkOverlapThreshold(
  start: number,
  end: number,
  mode: EventOverlapMode = 'second',
  threshold: number = 0
) {
  const duration: Record<EventOverlapMode, number> = {
    second: 1,
    minute: 60,
    hour: 3600,
    day: 86400,
  }

  const diff = Math.ceil((toMoment(end).startOf(mode).unix() - start) / duration[mode])
  return diff >= threshold
}
